import omitBy from 'lodash/omitBy';
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import max from 'date-fns/max';
import min from 'date-fns/min';
import startOfDay from 'date-fns/start_of_day';
import endOfDay from 'date-fns/end_of_day';
import format from 'date-fns/format';

import {fetchWithState, getFetchedJSON} from '~/misc/fetch';
import toLegacyLoad from '~/misc/toLegacyLoad';
import recaptcha from '~/misc/recaptcha';
import HTTPError from '~/misc/HTTPError';

const notEmpty = (data) => {
  const result = omitBy(data, isNil);
  return isEmpty(result) ? null : result;
};


const queryLocation = (data, state) => (state
  ? {
    states: [state],
  }
  : {
    geo: notEmpty({
      location: data.location,
      deadhead: isNil(data.deadhead) ? null : {max: data.deadhead},
    }),
  });

const getRequest = (data) => notEmpty({
  query: notEmpty({
    dots: notEmpty({
      eq: get(data, 'dots.eq'),
      neq: get(data, 'dots.neq'),
    }),
    pickup: notEmpty({
      date_local: get(data, 'dates.length') ? notEmpty({
        from: format(startOfDay(min(...data.dates)), 'YYYY-MM-DDTHH:mm:ss'),
        to: format(endOfDay(max(...data.dates)), 'YYYY-MM-DDTHH:mm:ss'),
      }) : null,
      ...data.pick_up && queryLocation(data.pick_up, data.pick_up.location_state),
    }),
    drop_off: data.drop_off && notEmpty(queryLocation(
      data.drop_off,
      data.drop_off.location_state
    )),
    /*
      "distance": {
        "min": 10,
        "max": 1000
      }*/
    load_size: (data.load_size === 'any' || !data.load_size) ? null : data.load_size,
    weight: notEmpty({
      max: parseFloat(data.max_weight) || null,
      min: parseFloat(data.min_weight) || null,
      allow_null: !!data.weight_allow_null || null,
    }),
    length: notEmpty({
      // max: parseFloat(data.max_length) || null,
      // min: 0,
      allow_null: !!data.length_allow_null || null,
    }),
    equipment: get(data, 'equipment.length') ? data.equipment : null,
    book_now: true,
  }),
  options: {
    // book_now_first: Boolean(data.pick_up),
  },
  sort: data.sort_by ? [
    {[data.sort_by]: data.sort_order},
  ] : null,
});

const markCreatedAt = (since) => {
  const searchSince = new Date(since);
  return (item) => {
    const createdAt = item.created_at || (searchSince - item.age);
    return toLegacyLoad(item, createdAt);
  };
};

export const liveSearch = (getState, data, searchSince) => {
  const request = getRequest(data);

  return fetchWithState(getState, {
    url: '/shipments/search/liveloads',
    method: 'POST',
    body: {
      criteria: request,
      search_since: searchSince,
    },
  }).then(getFetchedJSON).then((response) => (response.status === 'ok' && {
    new_shipments: response.new_shipments && response.new_shipments
      .filter(item => item)
      .map(markCreatedAt(response.search_since)),
    deleted_shipments: response.deleted_shipments,
    search_since: response.search_since,
  }));
};


const search = (getState, data, skipToken) => recaptcha('tl_search_filter').then(token => searchDirectly(getState, data, skipToken, token))

const searchDirectly = (getState, data, skipToken, rGtoken) => {
  const request = {
    ...getRequest(data),
    ...notEmpty({
      limit: Math.min(data.limit, 200),
      offset: data.offset,
    }),
  };
  const header = {
    favorite: data.show_option === 'All' || !data.show_option ? 0 : 1,
  };
  request['options'] = {...(request['options'] || {}),'include_auth_required': true};
  return fetchWithState(getState, {
    // url: '/shipments/search',
    // url: '/tl/search/filter',
    url:'/tl/search/filter/inside',
    method: 'POST',
    body: request,
    header: {
      ...header,
      "recaptcha-token": rGtoken
    },
  }, skipToken).then(getFetchedJSON).then((response) => {
    const {code, message} = response;
    if(code === 423) {
      throw new HTTPError({
        status: 423,
        message
      })
    }
    return {
      shipments: response.items && response.items
        .filter(item => item)
        .map(markCreatedAt(response.search_since)),
      total_shipments: get(response, 'meta.total'),
      search_since: response.search_since,
      searchId: response.search_id,
    }
    
  }).catch(error => {
    throw error;
  })
};

export const searchDetailsList = (getState, data) => {
  data['options'] = {...(data['options'] || {}),'include_auth_required': true};
  return fetchWithState(getState, {
    // url: '/tl/search/filter',
    url:'/tl/search/filter/inside',
    method: 'POST',
    body: data,
  }).then(getFetchedJSON);
}

export default search;



// WEBPACK FOOTER //
// ./src/api/search.js